module.exports = __webpack_public_path__ + "img/icon-success2.3addc7b2.png";